import React from 'react';
import { useQuery } from 'react-query';
import { apiClient } from '../lib/api';

const ApiStatus: React.FC = () => {
  const { data, isLoading, error } = useQuery(
    'api-status',
    () => apiClient.getPosts({ page: 1, limit: 1 }),
    {
      retry: false,
      refetchInterval: 30000, // Проверяем каждые 30 секунд
    }
  );

  if (isLoading) {
    return (
      <div className="fixed bottom-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-2 rounded-md text-sm">
        Проверка подключения...
      </div>
    );
  }

  if (error) {
    return (
      <div className="fixed bottom-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded-md text-sm">
        Ошибка подключения к API
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded-md text-sm">
      API подключен
    </div>
  );
};

export default ApiStatus; 